import { Alert } from '@atoms/Alert';
import { SnackbarProvider as NotistackProvider } from 'notistack';
import { forwardRef } from 'react';
import { CustomContentProps } from 'notistack';
import { Stack as MuiStack } from '@mui/material';

const SnackbarComponent = forwardRef<HTMLDivElement, CustomContentProps>(
  (props, ref) => {
    const { message, variant } = props;

    return (
      <MuiStack ref={ref}>
        <Alert severity={variant === 'default' ? 'success' : variant}>
          {message}
        </Alert>
      </MuiStack>
    );
  },
);

SnackbarComponent.displayName = 'SnackbarComponent';

export default function SnackbarProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <NotistackProvider
      dense
      maxSnack={5}
      autoHideDuration={3000}
      Components={{
        default: SnackbarComponent,
        success: SnackbarComponent,
        error: SnackbarComponent,
        warning: SnackbarComponent,
        info: SnackbarComponent,
      }}
      preventDuplicate
    >
      {children}
    </NotistackProvider>
  );
}
